export enum AccountType {
    Checking = "C",
    GeneralLedger = "G",
    Savings = "S",
    CorporateChecking = "X",
}

export enum AccountTypeUI {
    Checking = "Checking",
    GeneralLedger = "General Ledger",
    Savings = "Savings",
    CorporateChecking = "Corporate Checking",
}